import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ScriptLoaderService {
    loadAcceptJs(): void {
        const script = document.createElement('script');
        script.src = environment.production ? 'https://js.authorize.net/v1/Accept.js' : 'https://jstest.authorize.net/v1/Accept.js';
        script.async = true;
        document.body.appendChild(script);
    }
}
